(function () {
  'use strict';

  var DEBUG =
    window.WLH_KLAVIYO_DEBUG === true ||
    /[?&]wlhdebug\b/.test(window.location.search);

  function log() {
    if (DEBUG) console.log.apply(console, ['[wlh-klaviyo]'].concat([].slice.call(arguments)));
  }

  var WISHLIST_CONTAINERS = [
    '#wishlist-hero',
    '.wishlisthero-app',
    '[class*="wishlist-hero"]',
    '[class*="wlh-popup"]',
    '[class*="wlh-modal"]',
    '[class*="wlh-overlay"]',
    '[class*="wlh-drawer"]',
    '[id*="whlero"]',
    '[class*="whlero"]'
  ];

  function isVisible(el) {
    if (!el) return false;
    var cs = getComputedStyle(el);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && el.offsetWidth > 0 && el.offsetHeight > 0;
  }

  function wishlistIsOpen() {
    for (var i = 0; i < WISHLIST_CONTAINERS.length; i++) {
      var els = document.querySelectorAll(WISHLIST_CONTAINERS[i]);
      for (var j = 0; j < els.length; j++) {
        var cs = getComputedStyle(els[j]);
        if ((cs.position === 'fixed' || cs.position === 'absolute') && isVisible(els[j])) {
          return els[j];
        }
      }
    }
    return null;
  }

  function closeWishlistModal() {
    var open = wishlistIsOpen();
    if (!open) {
      log('no open WishlistHero modal detected');
      return;
    }
    log('WishlistHero modal open, closing:', open);

    var closeBtn = document.querySelector(
      [
        '[class*="wlh"] [class*="close"]',
        '[class*="wishlist-hero"] [class*="close"]',
        '[id*="whlero"] [class*="close"]',
        '[class*="wlh"] [aria-label*="lose"]',
        '[class*="wishlist-hero"] [aria-label*="lose"]'
      ].join(', ')
    );
    if (closeBtn && isVisible(closeBtn)) {
      log('clicking close button', closeBtn);
      closeBtn.click();
    }

    document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', keyCode: 27, which: 27, bubbles: true }));

    if (window.location.hash === '#hero-wishlist') {
      log('clearing #hero-wishlist hash');
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }

    requestAnimationFrame(function () {
      var stillOpen = wishlistIsOpen();
      if (stillOpen) {
        log('still open after app close — hiding directly', stillOpen);
        stillOpen.style.setProperty('display', 'none', 'important');
        // Mark so we can undo on the next genuine reopen click.
        stillOpen.setAttribute('data-wlh-klaviyo-hidden', 'true');
      }
    });
  }

  document.addEventListener(
    'click',
    function (e) {
      var trigger = e.target.closest && e.target.closest('a[href="#hero-wishlist"], .wishlist-hero-header-icon');
      if (!trigger) return;
      document.querySelectorAll('[data-wlh-klaviyo-hidden="true"]').forEach(function (el) {
        el.style.removeProperty('display');
        el.removeAttribute('data-wlh-klaviyo-hidden');
        log('restored previously hidden WishlistHero modal for reopen');
      });
    },
    true
  );

  window.addEventListener('klaviyoForms', function (e) {
    var detail = e && e.detail;
    log('klaviyoForms event', detail && detail.type, detail && detail.formId);
    if (detail && (detail.type === 'open' || detail.type === 'embedOpen')) {
      closeWishlistModal();
    }
  });

  log('initialized');
})();
